import { ClipboardCheck } from 'lucide-react';
import { Badge } from '@proerp/ui';
import { useQmProcesses } from '@/features/qm/qmApi';
import { TaskCard, TaskRow } from './TaskCard';

/** Offene Status eines QM-Prozesses (nicht abgeschlossen/verworfen). */
const OPEN_QM_STATUSES = new Set(['OPEN', 'IN_PROGRESS']);

/**
 * Meine QM-Prozesse (ADR 0062): serverseitig auf ownerUserId === ctx.userId
 * gefiltert (`mine=true`). Zeigt bevorzugt die noch offenen zuerst.
 */
export function MyQmWidget() {
  const query = useQmProcesses({ mine: true });
  const all = query.data?.data ?? [];
  // Offene zuerst; abgeschlossene ans Ende (Anzeige-Sortierung, keine Filterung).
  const items = [...all].sort((a, b) => Number(OPEN_QM_STATUSES.has(b.status)) - Number(OPEN_QM_STATUSES.has(a.status)));

  return (
    <TaskCard
      title="Meine QM-Prozesse"
      icon={ClipboardCheck}
      isLoading={query.isLoading}
      isEmpty={items.length === 0}
      emptyText="Dir ist kein QM-Prozess zugewiesen."
    >
      {items.slice(0, 6).map((process) => (
        <TaskRow
          key={process.id}
          to={`/qm/${process.id}`}
          left={
            <>
              <span className="font-mono text-xs text-muted-foreground">{process.number}</span>
              <span className="ml-2 text-foreground">{process.title}</span>
            </>
          }
          right={<Badge tone={OPEN_QM_STATUSES.has(process.status) ? 'warning' : 'neutral'}>{process.status}</Badge>}
        />
      ))}
    </TaskCard>
  );
}
